import { ComponentWithContextProps } from 'lib/component-props';
import EEPlaceholder from 'components/Sections/EEPlaceholder';
import { useI18n } from 'next-localization';
import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { useEffect, useState } from 'react';

const ShareScreen = ({ sitecoreContext }: ComponentWithContextProps) => {
  const { t } = useI18n();
  const [cobrowseCode, setCobrowseCode] = useState('');

  const generateCode = () => {
    window['CobrowseIO'].client().then(() => {
      window['CobrowseIO'].createSessionCode().then((code) => {
        setCobrowseCode(`${t('screenShareCodeMessage')} ${code}`);
      });
    });
  };

  useEffect(() => {
    if (!sitecoreContext.pageEditing) {
      const promise = new Promise((resolve) => {
        window['CobrowseIO'] = {
          client: () => {
            const script = document.createElement('script');
            script.src = 'https://js.cobrowse.io/CobrowseIO.js';
            script.async = true;
            document.head.appendChild(script);
            script.onload = () => {
              resolve(window['CobrowseIO']);
            };
            return promise;
          },
        };
      });

      window['CobrowseIO'].license = 'eu_PseHgVOKlgXSdw';
      window['CobrowseIO'].api = 'https://eu.cobrowse.io';
      window['CobrowseIO'].client().then(() => {
        window['CobrowseIO'].start();
      });
    }
  }, [sitecoreContext.pageEditing]);

  if (sitecoreContext.pageEditing) {
    return <EEPlaceholder>Share screen</EEPlaceholder>;
  }

  return (
    <section className="default-section-padding background-digital-light-grey">
      <div className="container">
        <div className="d-flex flex-column align-items-center mb-2">
          <h2 className="my-2">{t('screenShareTitle')}</h2>
          <p className="mb-2">{t('screenShareDescription')}</p>
          <AbrdnButton buttonType="primary" className="mb-2" onClick={generateCode}>
            <span>{t('startScreenShare')}</span>
          </AbrdnButton>
          {cobrowseCode !== '' && <h4>{cobrowseCode}</h4>}
        </div>
      </div>
    </section>
  );
};

export default ShareScreen;
